import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// All API calls include credentials for auth cookies
const ax = axios.create({ baseURL: API, withCredentials: true });

export const api = {
  // Auth
  login: (email, password) => ax.post("/auth/login", { email, password }).then(r => r.data),
  register: (email, password, name) => ax.post("/auth/register", { email, password, name }).then(r => r.data),
  logout: () => ax.post("/auth/logout").then(r => r.data),
  getMe: () => ax.get("/auth/me").then(r => r.data),
  refreshToken: () => ax.post("/auth/refresh").then(r => r.data),
  updateSettings: (bankroll, kellyFraction) =>
    ax.put("/user/settings", { bankroll, kelly_fraction: kellyFraction }).then(r => r.data),

  // Leagues & Fixtures
  getLeagues: () => ax.get("/leagues").then(r => r.data),
  getFixtures: (leagueCode) => ax.get(`/fixtures/${leagueCode}`).then(r => r.data),
  getPrediction: (fixtureId, bankroll = 1000, kellyFraction = 0.5) =>
    ax.get(`/prediction/${fixtureId}`, {
      params: { bankroll, kelly_fraction: kellyFraction }
    }).then(r => r.data),

  // Data Refresh
  refreshLeagueData: (leagueCode) => ax.post(`/data/refresh/${leagueCode}`).then(r => r.data),
  refreshAllLeagues: () => ax.post("/data/refresh-all").then(r => r.data),

  // Bets & ROI
  recordBet: (bet) => ax.post("/bets/record", bet).then(r => r.data),
  getRoi: () => ax.get("/bets/roi").then(r => r.data),
  getBetHistory: (limit = 50) => ax.get("/bets/history", { params: { limit } }).then(r => r.data),

  // Stats & Monitoring
  getCornerStats: (leagueCode) => ax.get(`/stats/corners/${leagueCode}`).then(r => r.data),
  getCacheStats: () => ax.get("/cache/stats").then(r => r.data),
  getApiStatus: () => ax.get("/monitor/status").then(r => r.data),
  getHealth: () => ax.get("/health").then(r => r.data),

  // Live Data & Standings
  getLiveData: (fixtureId) => ax.get(`/live/${fixtureId}`).then(r => r.data),
  getStandings: (leagueCode) => ax.get(`/standings/${leagueCode}`).then(r => r.data),
  
  // Top Tips
  getTopTips: (bankroll = 1000) =>
    ax.get("/tips/top", { params: { bankroll } }).then(r => r.data),
  getValueBetsToday: (bankroll = 1000) =>
    ax.get("/valuebets/today", { params: { bankroll } }).then(r => r.data),

  // Feedback
  submitFeedback: (message, email) =>
    ax.post("/feedback", { message, email }).then(r => r.data),
  getFeedbackList: () => ax.get("/feedback/list").then(r => r.data),
};
